import * as React from 'react';
import styled from 'styled-components';

export interface ModalProps {
  children: React.ReactNode;
  active?: boolean; // pick between using the prop or the setActive() method to set state
  dismissable?: boolean;
  onDismiss?: () => void;
  showDarkOverlay?: boolean;
  overlayOpacity?: number;
  className?: string;
}

interface ModalState {
  active: boolean;
}

const ModalContainer = styled.div<{ active: boolean }>`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: ${(props) => (props.active ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
`;

const Overlay = styled.div<{ visible: boolean, opacity: number }>`
  opacity: ${({ visible, opacity }) => (visible ? opacity : 0)};
  z-index: -1;
`;

export class Modal extends React.Component<ModalProps, ModalState> {
  constructor(props) {
    super(props);
    this.state = { active: false };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.keydownListener);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownListener);
  }

  setActive(value: boolean, cb?: () => void) {
    const { active } = this.state;
    if (active === value) return;
    this.setState({ active: value }, cb);
  }

  keydownListener = ({ keyCode }: KeyboardEvent) => {
    if (keyCode !== 27) return;
    const { dismissable = false } = this.props;
    if (dismissable) this._dismiss();
  };

  _dismiss = () => {
    const { active, onDismiss } = this.props;
    onDismiss?.();
    if (typeof active === 'undefined') this.setActive(false);
  };

  render() {
    const {
      children, active: activeProp, showDarkOverlay, dismissable, overlayOpacity = 0.5, className,
    } = this.props;
    const { active } = this.state;
    return (
      <ModalContainer active={typeof activeProp === 'boolean' ? activeProp : active} className={className}>
        <Overlay
          visible={showDarkOverlay}
          className="ui-popup-screen ui-overlay-inherit"
          onClick={dismissable && this._dismiss}
          opacity={overlayOpacity}
        />
        {children}
      </ModalContainer>
    );
  }
}
